import { Link } from "react-router-dom";
import Logo from "@/components/Logo";

const COLS = [
    {
        title: "Contractors",
        links: [
            { label: "Salary Packaging", to: "/services" },
            { label: "Novated Leasing", to: "/#leasing" },
            { label: "Superannuation", to: "/superannuation" },
            { label: "BankIT", to: "/services" },
            { label: "Join PayMe", to: "/join" },
        ],
    },
    {
        title: "Company",
        links: [
            { label: "About", to: "/about" },
            { label: "Services", to: "/services" },
            { label: "Recruitment Companies", to: "/recruitment-company" },
            { label: "Blog", to: "/blog" },
            { label: "Portal", to: "/portal" },
        ],
    },
];

function FooterLink({ l }) {
    const cls = "text-base text-foreground/80 transition-colors hover:text-primary";
    if (l.href) return <a href={l.href} target="_blank" rel="noopener noreferrer" className={cls}>{l.label}</a>;
    return <Link to={l.to} className={cls}>{l.label}</Link>;
}

export default function Footer() {
    return (
        <footer data-testid="site-footer">
            <div className="mx-auto grid max-w-7xl gap-10 px-5 py-16 md:px-8 lg:grid-cols-4">
                <div>
                    <Logo className="h-16" />
                    <p className="mt-5 text-base text-foreground/80">PayMe Australia Pty Ltd<br />ABN 80 130 125 334</p>
                    <p className="mt-3 text-base text-foreground/80">Australian, family owned and veteran owned.</p>
                </div>
                {COLS.map((c) => (
                    <div key={c.title}>
                        <p className="font-semibold">{c.title}</p>
                        <ul className="mt-4 space-y-2.5">
                            {c.links.map((l) => <li key={l.label}><FooterLink l={l} /></li>)}
                        </ul>
                    </div>
                ))}
                <div>
                    <p className="font-semibold">Contact</p>
                    <ul className="mt-4 space-y-2.5 text-base text-foreground/80">
                        <li><a href="tel:1800082006" className="hover:text-primary" data-testid="footer-phone-link">1800 082 006</a></li>
                        <li><a href="tel:+61261517000" className="hover:text-primary">International +61 2 6151 7000</a></li>
                        <li><a href="mailto:enquiries@payme.com.au" className="hover:text-primary" data-testid="footer-email-link">enquiries@payme.com.au</a></li>
                        <li><a href="mailto:timesheets@payme.com.au" className="hover:text-primary" data-testid="footer-timesheets-link">timesheets@payme.com.au</a></li>
                        <li><Link to="/portal" className="hover:text-primary" data-testid="footer-portal-link">Timesheets and Payslips</Link></li>
                    </ul>
                </div>
            </div>
            <div className="bg-primary text-primary-foreground">
                <div className="mx-auto flex max-w-7xl flex-wrap items-center gap-x-6 gap-y-2 px-5 py-4 text-sm md:px-8">
                    <span>© 2026 PayMe Australia Pty Ltd</span>
                    <Link to="/privacy-policy" className="hover:underline">Privacy Policy</Link>
                    <Link to="/disclaimer" className="hover:underline">Disclaimer</Link>
                    <Link to="/contact-us" className="hover:underline">Contact Us</Link>
                    <span className="ml-auto text-xs text-white/80" data-testid="footer-disclaimer">Calculator figures are indicative estimates only — not financial advice. ATO rates 2025/26.</span>
                </div>
            </div>
        </footer>
    );
}
